export const OFFICES = {
  main: {
    label: 'Loadsmart Headquarters',
    address: '175 W. Jackson Blvd Suite 1400',
    city: 'Chicago',
    state: 'IL',
    zipcode: '60604',
  },
};
